//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { DesignExtra } from "@/utils/dto/objects.js";
import { adjustColorBrightness } from "@/utils/helpers.js";
import { BUILD_STORAGE_PATH, STORAGE_BACKGROUND_PATH } from "@/constants/ui.js";

export default {
  name: 'Accent',
  components: { IconView },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    tgb: {
      type: Object,
      default: () => ({})
    },
    objectLabel: {
      type: String,
      required: false,
      default: () => ''
    },
    objectId: {
      type: String,
      default: ''
    },
    design: {
      type: String,
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => ({})
    },
    template: {
      type: Object,
      default: () => null
    },
    theme: {
      type: String,
    },
    listInfo: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    isArt: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      domId: '',
      bgImageUrl: '',
    }
  },
  computed: {
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }
      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }
      return null;
    },
    /** Загруженное изображение (слева 40%) */
    hasUploadedImage() {
      const bg = this.tgb?.background;
      return !!(bg && (bg.image_depot_id || bg.image_uploaded) && !bg.background_id);
    },
    /** Фон из каталога (100% блока, как в WithBg) */
    hasBackground() {
      const bg = this.tgb?.background;
      return !!(bg && bg.background_id);
    },
    containerClasses() {
      return {
        '--with-uploaded-image': this.hasUploadedImage,
        '--with-background': this.hasBackground,
        '--with-icon': this.tgb.icon,
      }
    },
    containerStyle() {
      if (!this.hasBackground) {
        return this.getBg ? { background: this.getBg } : {};
      }
      return {};
    },
    contentClasses() {
      return {
        '--with-uploaded-image': this.hasUploadedImage,
        '--with-first-block-bg': !!this.getFirstBlockBgColor,
      }
    },
    innerBlockStyle() {
      if (!this.getFirstBlockBgColor) return {};
      const bg = this.getFirstBlockBgGradientEnabled
        ? `linear-gradient(to ${this.getFirstBlockBgGradientDirection}, ${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness(this.getFirstBlockBgColor, 1.20)}`})`
        : this.getFirstBlockBgColor;
      return { background: bg };
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getFirstBlockBgColor() {
      return this.design_extra?.first_block?.bg_color ?? null;
    },
    getFirstBlockBgGradientEnabled() {
      return this.design_extra?.first_block?.gradient_enabled ?? false;
    },
    getFirstBlockBgGradientDirection() {
      return this.design_extra?.first_block?.gradient_direction ?? 'bottom';
    },
    getFirstBlockBgGradientShadowDirection() {
      return this.design_extra?.first_block?.gradient_shadow_direction ?? 'transparent';
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? 'rgba(0, 0, 0, 0.65)';
    },
    getIconBg() {
      if (this.iconBgPalette) {
        return { backgroundColor: this.iconBgPalette.main_color };
      }
      if (this.design_extra?.icon_bg?.color) {
        return { backgroundColor: this.design_extra.icon_bg.color };
      }
      return null;
    },
    getBgGradientEnabled() {
      return this.design_extra?.bg?.gradient_enabled ?? false;
    },
    getBgGradientDirection() {
      return this.design_extra?.bg?.gradient_direction ?? 'bottom';
    },
    getBgGradientShadowDirection() {
      return this.design_extra?.bg?.gradient_shadow_direction ?? 'transparent';
    },
    getBgColor() {
      if (this.bgPalette) return this.bgPalette.main_color;
      if (this.design_extra?.bg?.color) return this.design_extra.bg.color;
      return null;
    },
    getBg() {
      if (!this.getBgColor) return null;
      if (this.getBgGradientEnabled) {
        return `linear-gradient(to ${this.getBgGradientDirection}, ${this.getBgGradientShadowDirection === 'transparent' ? `${this.getBgColor}, transparent` : `${this.getBgColor}, ${adjustColorBrightness(this.getBgColor, 1.20)}`})`;
      }
      return this.getBgColor;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'black';
    },
    imagePath() {
      if (!this.tgb?.background) return '';
      if (this.tgb.background.type === 'image' && this.tgb.background.background_id) {
        return this.bgImageUrl;
      }
      return BUILD_STORAGE_PATH(this.isArt ? 'materials' : 'object_tgb_images', this.tgb.background.image_depot_id || this.tgb.background.image_uploaded);
    },
  },
  async mounted() {
    this.domId = `tgbs-${this.listInfo.id}`;
    if (this.tgb?.background?.background_id) {
      await this.$store.dispatch('backgrounds/fetchPublicObject', this.tgb.background.background_id).then((item) => {
        this.bgImageUrl = this.$addServerPath(`${STORAGE_BACKGROUND_PATH}${item.picto}`);
      });
    }
  },
}
